import env from '../env';
import { isBrowser } from './environment';
import { Debug } from '@svt/debug';
const { info } = Debug('play:hotjar:debug');

export function triggerPoll(triggerName = '') {
    if (env.FLAG_ENABLE_HOTJAR && isBrowser() && typeof window.hj === 'function') {
        info(`Running Hotjar trigger: ${triggerName}`);
        window.hj('trigger', triggerName);
    }
}
